import PropTypes from "prop-types";
// @mui
import { styled } from "@mui/material/styles";
import { Box, Stack, AppBar, Toolbar, IconButton, Typography } from "@mui/material";
// utils
import { bgBlur } from "../../../utils/cssStyles";
// components
import Iconify from "../../../components/iconify";
//
import Searchbar from "./Searchbar";
import AccountPopover from "./AccountPopover";
import LanguagePopover from "./LanguagePopover";
import NotificationsPopover from "./NotificationsPopover";
import { getlocalStorageUserObject } from "../../../helper/LocalStorageHelper";

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;
const HEADER_BG_COLOR = "#fff";

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: "none",
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up("lg")]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  let headingStr = "";

  let storedUser = getlocalStorageUserObject();
  // console.debug("Header: storedUser=", storedUser);
  if (storedUser && storedUser.orgNameZh) {
    headingStr = storedUser.orgNameZh || storedUser.orgNameEn;
  } 


  return (
    <StyledRoot sx={{ bgcolor: HEADER_BG_COLOR }}>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: "text.primary",
            display: { lg: "none" },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        {/* <Searchbar /> */}

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={{
            xs: 0.5,
            sm: 1,

          }}
          sx={{ width: '100%' }}
        >
          <Box>
            <Typography variant="h5" sx={{ color: 'text.primary', fontWeight: 'bold' }}>
              {headingStr}
            </Typography>
          </Box>
          {/* <LanguagePopover />
          <NotificationsPopover /> */}
          <AccountPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
